import * as React from 'react'
import { useEffect, useRef, useState } from 'react'
import AliceCarousel from 'react-alice-carousel'
import 'react-alice-carousel/lib/alice-carousel.css'
import { useTranslation } from 'react-i18next'
// import {api} from '../api/api'
import '../css/caseStudies.css'
import { tagger } from '../util/util'

interface Result {
    percents: string
    description: string
    isArrowDown?: true
}

interface Case {
    id: number
    image: string
    title: string
    description: string
    results?: {
        first: Result
        second?: Result
    }
    readMore: string
    download?: string
}

function* generateId() {
    let i = 0
    while (true) {
        yield i++
    }
    return i
}
const idGenerator = generateId()


const allCases: Case[] = [
    {
        id: idGenerator.next().value,
        image: 'https://static.persona.ly/images/rtb/rapido.webp',
        title: 'Rapido',
        description: 'Learn how we outperformed Rapido Bike-Taxi App’s CPA KPI by 45% while scaling up the campaign x13',
        results: {
          first: {
            percents: '45%',
            description: 'lower CPA than the KPI',
            isArrowDown: true
          },
          second: {
              percents: 'x13',
              description: 'campaign scaling within 4 months'
          }
        },
        readMore: 'https://persona.ly/blog/2022/07/programmatic-user-acquisition-case-study-rapido/',
        download: 'https://content.cdn.personaly.bid/case_studies/Rapido%20Programmatic%20User%20Acquisition%20Case%20Study%20-%20Persona.ly.pdf'
    },
    {
        id: idGenerator.next().value,
        image: 'https://static.persona.ly/images/rtb/coinswitch.webp',
        title: 'CoinSwitch Kuber',
        description: 'Learn how we managed to target users with a high probability of conversion based on four deep-funnel KPIs representing user flow at different stages of the user funnel for CoinSwitch cryptocurrency exchange platform.',
        results: {
          first: {
            percents: 'x3.1',
            description: 'FTD CVR higher than KPI'
          },
          second: {
              percents: 'x3.7',
              description: 'KYC to FTD ratio higher than KPI'
          }
        },
        readMore: 'https://persona.ly/blog/2022/06/programmatic-ua-coinswitch/',
        download: 'https://content.cdn.personaly.bid/case_studies/CoinSwitch%20Programmatic%20UA%20case%20study.pdf'
    },
    {
        id: idGenerator.next().value,
        image: 'https://static.persona.ly/images/rtb/waitr.webp',
        title: 'Waitr',
        description: 'Learn how we collaborated with Pipar\\TBWA to re-engage Waitr’s users in US and exceeded CPA KPI',
        results: {
            first: {
                percents: '19%',
                description: 'lower D7 FTD Cost',
                isArrowDown: true
            }
        },
        readMore: 'https://persona.ly/blog/2022/05/programmatic-re-egagement-waitr/',
        download: 'https://content.cdn.personaly.bid/case_studies/Waitr%20-Programmatic%20Re-engagement%20Case%20Study%20-%20Persona.ly.pdf'
    },
    {
        id: idGenerator.next().value,
        image: 'https://static.persona.ly/images/rtb/rummycircle.webp',
        title: 'RummyCircle',
        description: 'Learn how we Achieved D7 FTD Cost 53% Below KPI for Games24x7’s RummyCircle',
        results: {
            first: {
                percents: '53%',
                description: 'lower D7 FTD Cost'
            },
            second: {
                percents: '15x',
                description: 'installs growth in two months'
            }
        },
        readMore: 'https://persona.ly/blog/2022/03/how-we-achieved-d7-ftd-cost-53-below-kpi-for-games24x7s-rummycircle/',
        download: 'https://content.cdn.personaly.bid/case_studies/RummyCircle_UA%20Strategy%20Case%20Study.pdf'
    },
    {
        id: idGenerator.next().value,
        image: 'https://static.persona.ly/images/rtb/oktafx.webp',
        title: 'OctaFX',
        description: 'Learn how we reached 83% Deep Funnel Conversion and increased account generation conversion by 50% within a month of starting campaigns for OctaFX.',
        results: {
            first: {
                percents: '83%',
                description: 'Deep Funnel Conversion'
            },
            second: {
                percents: '50%',
                description: 'increase in 30D Cost Recoup'
            }
        },
        readMore: 'https://persona.ly/blog/2022/03/how-we-outperformed-octafx-kpi-reaching-83-deep-funnel-conversion/',
        download: 'https://personartb-cdn.s3.us-east-2.amazonaws.com/case_studies/OctaFX_Case_Study_032022.pdf'
    },
    {
        id: idGenerator.next().value,
        image: 'https://static.persona.ly/images/rtb/yurufuwa.webp',
        title: 'Yurufuwa',
        description: 'Learn how we helped launch and scale KYOTOMA Inc.\'s Yurufuwa, reaching CPI 25% cheaper than the target while boosting organic install volume x40.',
        results: {
            first: {
                percents: '25%',
                description: 'below CPI Goal'
            },
            second: {
                percents: '4100%',
                description: 'organic volume increase'
            }
        },
        readMore: 'https://persona.ly/blog/2022/02/how-we-helped-launch-and-scale-kyotoma-inc-s-yurufuwa-while-boosting-organic-install-volume-x40/',
        download: 'https://personartb-cdn.s3.us-east-2.amazonaws.com/case_studies/Persona.ly_Yurufuwa_0222_English.pdf'
    },
    {
        id: idGenerator.next().value,
        image: 'https://static.persona.ly/images/rtb/wondersquad.webp',
        title: '33RD: Random Defense',
        description: 'Learn how we beat other paid and organic in retention and exceeded the D7 KPI by 40%, as well as reaching 45% D7 ROAS within several weeks of learning.',
        results: {
            first: {
                percents: '40%',
                description: 'D7 Retetion above KPI'
            },
            second: {
                percents: '97%',
                description: 'higher D7 retention than others'
            }
        },
        readMore: 'https://persona.ly/blog/2022/01/how-we-reached-45-d7-roas-for-33rd-random-defense/',
        download: 'https://personartb-cdn.s3.us-east-2.amazonaws.com/case_studies/33RD%20CS_150P_EN.pdf'
    },
    {
        id: idGenerator.next().value,
        image: 'https://static.persona.ly/images/rtb/fish_idle.webp',
        title: 'Fish Idle',
        description: 'Learn how we were able to reach D7 retention 5x higher than organic and beat ROAS goals several weeks for Fish Idle in the US by targeting look-a-like audiences generated based around the combination of both fishing and idle mechanics.',
        results: {
            first: {
                percents: '37%',
                description: 'lifetime ROAS Lift (week 4)'
            },
            second: {
                percents: '500%',
                description: 'higher D7 retention'
            }
        },
        readMore: 'https://persona.ly/blog/2021/07/persona-lys-achieves-d7-retention-5x-higher-than-organic-for-mamboo-games-fish-idle/',
        download: 'https://personartb-cdn.s3.us-east-2.amazonaws.com/case_studies/ply_mamboo_case_study_editable_en_1a.pdf'
    },
    {
        id: idGenerator.next().value,
        image: 'https://static.persona.ly/images/rtb/solitaire.webp',
        title: 'Solitaire Cash',
        description: 'Learn how we beat the ROAS KPI as well as the organic conversion towards purchases by targeting luser’s whose behavior indicated they are losing interest in a similar alternative app, allowing us to show them an ad for Solitaire Cash, a better alternative with more content and active users.',
        results: {
            first: {
                percents: '90%',
                description: 'D7 ROAS lift (week 4)'
            },
            second: {
                percents: '130%',
                description: 'higher FTD CVR (week 4)'
            }
        },
        readMore: 'https://persona.ly/blog/2021/06/persona-lys-exceeds-papaya-gamings-roas-kpis-by-90/',
        download: 'https://personartb-cdn.s3.us-east-2.amazonaws.com/case_studies/ply_solitaire_cash_case_study_digital_en_1a.pdf'
    },
    {
        id: idGenerator.next().value,
        image: 'https://static.persona.ly/images/rtb/coindcx.webp',
        title: 'CoinDCX Go',
        description: 'Read how we beat CPA and engagement KPIs by targeting lookalike audiences that showed interest in crypto or trading in general and gradually modeling towards each step in their extremely effective onboarding funnel.',
        results: {
            first: {
                percents: '20%',
                description: 'lower CPA',
                isArrowDown: true
            },
            second: {
                percents: '18%',
                description: 'higher signup rate'
            }
        },
        readMore: 'https://persona.ly/blog/2021/05/persona-lys-programmatic-bidder-exceeds-coindcx-kpis/',
        download: 'https://personartb-cdn.s3.us-east-2.amazonaws.com/case_studies/ply_coindcx_case_study_digital_en_3a.pdf'
    },
    {
        id: idGenerator.next().value,
        image: 'https://static.persona.ly/images/rtb/ubisoft.webp',
        title: 'Ubisoft\'s Howrse',
        description: 'By modeling towards in-game progression events we\'ve managed to outperfom paid social campaigns and bring in more installs, higher retention, higher ROAS, and do so for a lower eCPI.',
        results: {
            first: {
                percents: '55%',
                description: 'more installs'
            },
            second: {
                percents: '200%',
                description: 'higher D7 retention'
            }
        },
        readMore: 'https://persona.ly/blog/2021/03/persona-ly-outperforms-paid-social-ua-for-ubisofts-howrse/',
        download: 'https://personartb-cdn.s3.us-east-2.amazonaws.com/case_studies/ply_ubisoft_howrse_case_study_digital_en_1a_upload.pdf'
    },
    {
        id: idGenerator.next().value,
        image: 'https://static.persona.ly/images/rtb/winjoy.webp',
        title: 'Zempot\'s WinJoy Poker',
        description: 'We integrated with Singular and received unattributed data which expedited our models\' learning curve and powered look-a-like audience generation. Over time, we were able to improve our prediction models and target the most engaged users, out of the payer population.',
        results: {
            first: {
                percents: '40%',
                description: 'D7 ROAS lift (month 1)'
            },
            second: {
                percents: '65%',
                description: 'D7 ROAS lift  (month 2)'
            }
        },
        readMore: 'https://persona.ly/blog/2021/02/case-study-zempots-winjoy-poker-ua-campaign-beats-roas-kpis/',
        download: 'https://personartb-cdn.s3.us-east-2.amazonaws.com/case_studies/ply_winjoy_poker_case_study_editable_en_1a.pdf'
    },
    {
        id: idGenerator.next().value,
        image: 'https://static.persona.ly/images/rtb/boxingstar.webp',
        title: '4:33\'s Boxing Star',
        description: 'By combining our intent-based targeting with time-related dimensions, we were able to reach valuable users, who are likely to make a purchase, at the most oprrotune time to convert them. We then implemented cross-learning techinques to expetied the process in our campaign in Korea',
        results: {
            first: {
                percents: '142%',
                description: 'D7 ROAS lift (US)'
            },
            second: {
                percents: '130%',
                description: 'D7 ROAS lift (KR)'
            }
        },
        readMore: 'https://persona.ly/blog/2021/02/how-we-exceeded-433-kpi-goals-for-their-leading-title-boxing-star/',
        download: 'https://personartb-cdn.s3.us-east-2.amazonaws.com/case_studies/ply_433_case_study_digital_en_1c.pdf'
    },
    {
        id: idGenerator.next().value,
        image: 'https://static.persona.ly/images/rtb/kingsthrone.webp',
        title: 'GOAT Games\' King\'s Throne',
        description: 'Combining intent-based targeting with engaged video and playable ads we were able to increase the install-to-purchase % for GOAT Games\' "King\'s Throne: Game of Lust"',
        results: {
            first: {
                percents: '144%',
                description: 'FTD CVR (Week 1)'
            },
            second: {
                percents: '209%',
                description: 'FTD CVR (Week 5)'
            }
        },
        readMore: 'https://persona.ly/blog/2020/11/case-study-goat-games-kings-throne/',
        download: 'https://personartb-cdn.s3.us-east-2.amazonaws.com/case_studies/ply_goatgames_case_study_digital_en_2a.pdf'
    },
    {
        id: idGenerator.next().value,
        image: 'https://static.persona.ly/images/rtb/lastdayonearth.webp',
        title: 'Kefir\'s Last Day on Earth',
        description: 'We integreted with Apssflyer\'s Audience feature and used their pre-defined segmentations to exptide our exploration. It allowed us to quickly beat both CPA and ROAS KPIs.',
        results: {
            first: {
                percents: '50%',
                description: 'Below CPA goal',
                isArrowDown: true
            },
            second: {
                percents: '250%',
                description: 'Above ROAS goal'
            }
        },
        readMore: 'https://persona.ly/blog/2020/09/kefirs-last-day-on-earth-retargeting-case-study/',
        download: 'https://personartb-cdn.s3.us-east-2.amazonaws.com/case_studies/ply_kefirgames_case_study_digital_en_2a.pdf'
    },
    {
        id: idGenerator.next().value,
        image: 'https://static.persona.ly/images/rtb/catgame.webp',
        title: 'Tilting Point\'s Cat Game',
        description: 'Running a LAT campaign for Tilting Point\'s "Cat Game", we used contextual targeting to reach users who showed interest in similar genres and delivered higher RR and 4x higher insall-to-purchase than organic traffic',
        results: {
            first: {
                percents: '20%',
                description: 'higher D3 RR'
            },
            second: {
                percents: '4x',
                description: 'higher FTD CVR'
            }
        },
        readMore: 'https://persona.ly/blog/2020/09/tilting-point-runs-contextually-driven-lat-ua-campaigns-with-persona-ly-ftds-increase/',
        download: 'https://personartb-cdn.s3.us-east-2.amazonaws.com/case_studies/ply_tiltingpoint_case_study_editable_en_1f.pdf'
    },
    {
        id: idGenerator.next().value,
        image: 'https://static.persona.ly/images/rtb/animoca.webp',
        title: 'Animoca\'s Crazy Defense Heroes',
        description: 'Using our proprietery machine-learning models, we were able to target the most engaged users, leading to our campaigns exceeding Animoca Brand\'s ROAS KPIs.',
        results: {
            first: {
                percents: '34%',
                description: 'D1 ROAS KPI'
            },
            second: {
                percents: '70%',
                description: 'D7 ROAS KPI'
            }
        },
        readMore: 'https://persona.ly/blog/2020/08/animoca-brands-crazy-defense-heroes-case-study/',
        download: 'https://personartb-cdn.s3.us-east-2.amazonaws.com/case_studies/ply_animoca_case_study_digital_en_1b.pdf'
    },
    {
        id: idGenerator.next().value,
        image: 'https://static.persona.ly/images/rtb/gamepoint.webp',
        title: 'GamePoint Bingo',
        description: 'By using our intent-based targeting and incorporating our proprietary age and gender prediction algorithms we were able to lower "GamePoint Bingo" eCPI costs and improve their ROAS over time.',
        results: {
            first: {
                percents: '23%',
                description: 'lower eCPI',
                isArrowDown: true
            }
        },
        readMore: 'https://persona.ly/blog/2020/06/gamepoint-bingo-programmatic-ua-case-study/',
        download: 'https://personartb-cdn.s3.us-east-2.amazonaws.com/case_studies/ply_gamepoint_case_study_digital_en_1b.pdf'
    },
    {
        id: idGenerator.next().value,
        image: 'https://static.persona.ly/images/rtb/ulu.webp',
        title: 'U.LU Games\' Reach Rich',
        description: 'Using ML-based algorithms, we were able not only to improve D1 retention, but also exceed U.LU Games\' ROAS KPIs for their leading title "Reach Rich"',
        results: {
            first: {
                percents: '107%',
                description: 'D30 ROAS lift'
            },
            second: {
                percents: '15%',
                description: 'D7 RR lift'
            }
        },
        readMore: 'https://persona.ly/blog/2020/04/u-lu-games-reach-rich-%eb%a6%ac%ec%b9%98%eb%a6%ac%ec%b9%98-programmatic-ua-case-study/',
        download: 'https://personartb-cdn.s3.us-east-2.amazonaws.com/case_studies/ply_ulu_case_study_digital_en_1b.pdf'
    },
    {
        id: idGenerator.next().value,
        image: 'https://static.persona.ly/images/rtb/bingo.webp',
        title: 'Clipwire Games’ Bingo Story™',
        description: 'Using intent-based targeting, we\'ve reached ROAS lifts for Clipwire Games’ leading title “Bingo Story™”',
        results: {
            first: {
                percents: '11%',
                description: 'D1 ROAS Lift'
            },
            second: {
                percents: '14.7%',
                description: 'D7 ROAS Lift'
            }
        },
        readMore: 'https://persona.ly/blog/2019/12/clipwire-games-bingo-story-programmatic-ua-case-study/',
        download: 'https://personartb-cdn.s3.us-east-2.amazonaws.com/case_studies/ply_clipwire_case_study_print_1a.pdf'
    },
    {
        id: idGenerator.next().value,
        image: 'https://static.persona.ly/images/rtb/bubble.webp',
        title: 'Ilyon’s Bubble Shooter™',
        description: 'By deploying our install probability feature, we were able to target engaged users and reach Ilyon\'s retention KPIs for their leading title "Bubble Shooter™"',
        results: {
            first: {
                percents: '18%',
                description: 'D1 RR Increase'
            },
            second: {
                percents: '32%',
                description: 'D7 RR Increase'
            }
        },
        readMore: 'https://persona.ly/blog/2019/09/ilyons-bubble-shooter-programmatic-ua-case-study/',
        download: 'https://personartb-cdn.s3.us-east-2.amazonaws.com/marketing/ply_ilyon_case_study_digital_3c.pdf'
    },
    {
        id: idGenerator.next().value,
        image: 'https://static.persona.ly/images/rtb/51.webp',
        title: 'Device Data Enrichment for UA',
        description: 'By adding 51Degrees’ Device Detection to their algorithms, some interesting device traits and fraud indicators were uncovered which were used to increase overall performance by 15%.',
        readMore: 'https://persona.ly/blog/2019/03/51degrees-device-detection-boosts-persona-lys-performance-by-15/'
    }
]


const CaseStudies = () => {
    // scrolling into view after all images loaded
    // required because some of safari versions don't handle hash links in right way
    useEffect(() => {
        if (location.hash !== '#case-studies') {
            return
        }

        const images = Array.from(document.querySelectorAll('img'))

        const imageReadyPromises = images.map(image => new Promise(resolve => {
            if (image.complete) {
                resolve(image)
            }
            image.addEventListener('load', () => {
                const interval = setInterval(() => {
                    if (image.naturalWidth > 0 && image.naturalHeight > 0) {
                        clearInterval(interval)
                        resolve(image)
                    }
                }, 20)
            })
            image.addEventListener('error', () => {
                resolve(image)
            })
        }))

        Promise.all(imageReadyPromises).then(() => {
            const caseStudiesAnchor = document.body.querySelector('#case-studies')
            caseStudiesAnchor?.scrollIntoView()
        })
    }, [])

    const { t, i18n } = useTranslation('rtb')

    const [cases, setCases] = useState<Case[]>([])

    const loadData = async () => {
        setCases(allCases)
    }

    useEffect(() => {
        loadData()
    }, [i18n.language])

    const handleOnDragStart = (e) => e.preventDefault()

    const addLineBreak = (text: string) => {
        if (!text.includes('(')) return text

        const bracketIndex = text.indexOf('(')
        return <>{text.slice(0, bracketIndex)}<br />{text.slice(bracketIndex)}</>
    }

    const renderCase = (item: Case) => {
        return (
            <div key={item.id} className="case-item-container">
                <div onDragStart={handleOnDragStart} className="case-item">
                    <a
                        className="carousel-inline-img case-image"
                        style={{ backgroundImage: 'url(' + item.image + ')' }}
                        href={item.readMore}
                        target="_blank"
                        rel="noopener noreferrer"
                    />
                    <div className="case-content">
                        <div className="user-name">{item.title}</div>
                        <div className="case-descr">{item.description}</div>
                        <div className="case-bottom-block">
                            {item.results &&
                                <div className="case-b-results">
                                    <div className="case-b-t">Results</div>
                                    <table><tbody>
                                        <tr>
                                            <td className="case-b-n aqua-text">
                                                <img src={`https://static.persona.ly/images/rtb/arrow-right-${item.results.first.isArrowDown ? 'down' : 'up'}-line.svg`} />
                                                {item.results.first.percents}
                                            </td>
                                            <td className="case-b-n aqua-text">
                                                {item.results.second &&
                                                    <img src={`https://static.persona.ly/images/rtb/arrow-right-${item.results.second.isArrowDown ? 'down' : 'up'}-line.svg`} />
                                                }
                                                {item.results.second?.percents}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="case-b-d">{addLineBreak(item.results.first.description)}</td>
                                            <td className="case-b-d">{addLineBreak(item.results.second?.description || '')}</td>
                                        </tr>
                                    </tbody></table>
                                </div>
                            }
                            <div>
                                <a href={item.readMore} target="_blank" rel="noopener noreferrer">
                                    <button className="button-review">Read More</button>
                                </a>
                                {item.download &&
                                    <a href={item.download} target="_blank" rel="noopener noreferrer">
                                        <button className="button-review button-aqua button-download">Download</button>
                                    </a>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const renderCaseList = () => {
        return cases
            .map((review: any) => renderCase(review))
    }
    const memoizedList = React.useMemo(renderCaseList, [cases])

    const carousel = useRef<AliceCarousel | null>(null)
    const [currentSlide, setCurrentSlide] = useState(0)

    const handlePrevPageChange = () => {
        let nextSlide = currentSlide - (currentSlide % 3 || 3)
        if (nextSlide < 0) {
            nextSlide = cases.length - (cases.length % 3 || 3)
        }
        carousel?.current?.slideTo(nextSlide)
    }

    const handleNextPageChange = () => {
        let nextSlide = currentSlide - currentSlide % 3 + 3
        if (nextSlide >= cases.length) {
            nextSlide = 0
        }
        carousel?.current?.slideTo(nextSlide)
    }

    const responsiveSettings = React.useMemo(() => ({
        0: {
            items: 1,
        },
        1105: {
            items: 3
        }
    }), [])

    return (
        <div className="case-studies">
            <span id="case-studies" className="case-studies-anchor" />
            <p className="muli">{tagger(t('Our case studies'), 'aqua-text')}</p>
            <div>
                <div className="cases carousel-inline">
                    <img
                        className={'prev not-mobile not-tablet prev-h'}
                        src="https://static.persona.ly/images/partners/path-2-copy-2.svg"
                        onClick={handlePrevPageChange}
                    />
                    <AliceCarousel
                        mouseTrackingEnabled
                        buttonsDisabled
                        onSlideChanged={e => setCurrentSlide(e.item)}
                        items={memoizedList}
                        ref={carousel}
                        responsive={responsiveSettings}
                        infinite={false}
                    />
                    <img
                        className={'next not-mobile not-tablet next-h'}
                        src="https://static.persona.ly/images/partners/path-2-copy-2.svg"
                        onClick={handleNextPageChange}
                    />
                </div>
            </div>
        </div>
    )
}

export default CaseStudies


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/caseStudies.tsx